import { render, staticRenderFns } from "./DragonPoolDialog.vue?vue&type=template&id=2a97ffdc&scoped=true"
import script from "./DragonPoolDialog.vue?vue&type=script&lang=js"
export * from "./DragonPoolDialog.vue?vue&type=script&lang=js"
import style0 from "./DragonPoolDialog.vue?vue&type=style&index=0&id=2a97ffdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a97ffdc",
  null
  
)

export default component.exports